var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styled, css } from "../utils";
import { darken } from 'polished';
var Wrapper = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a {\n      color: ", ";\n      font-weight: 600;\n      padding: 0 1rem;\n    }\n\n    a + a {\n      border-left: solid ", " 1px;\n    }\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    a {\n      color: ", ";\n      font-weight: 600;\n      padding: 0 1rem;\n    }\n\n    a + a {\n      border-left: solid ", " 1px;\n    }\n\n    &:hover {\n      color: ", ";\n    }\n  "])), colors.placeholder, colors.placeholder, darken(0.05, colors.placeholder));
});
var FooterLinks = function (_a) {
    var links = _a.links;
    return (React.createElement(Wrapper, null, links.map(function (_a) {
        var url = _a.url, text = _a.text, target = _a.target;
        return (React.createElement("a", { href: url, key: text, target: target }, text));
    })));
};
export default FooterLinks;
var templateObject_1;
//# sourceMappingURL=FooterLinks.js.map